import { SxProps, Theme } from '@mui/material';

export const mobileBlockerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  backgroundImage: `url(${import.meta.env.VITE_DO_SPACE_URL}/assets/mobile-blocker-bg.png)`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  height: '100dvh',
  textAlign: 'center',
  padding: '45px 24px 40px',
  'h3, p': {
    color: 'common.white',
  },
  img: {
    width: '61px',
  },
};

export const mobileLogoStyles: SxProps<Theme> = {
  marginBottom: 'auto',
};

export const p1Styles: SxProps<Theme> = {
  marginBottom: '24px',
  fontWeight: '600',
  fontSize: '32px',
  lineHeight: '38px',
};

export const p2Styles: SxProps<Theme> = {
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: '400px',
  marginBottom: '130px',
};
export const mobileFooterStyles: SxProps<Theme> = {
  fontSize: '13px',
  fontWeight: '400',
  lineHeight: '20px',
  color: 'customColors.blue.50',
  opacity: '0.5',
  marginTop: 'auto',
  a: {
    color: 'common.white',
  },
};
